<mat-toolbar
  class="bg-azul-sunedu page-title-container"
  fxLayoutAlign="center center">
  <div
    class="toolbar-title"
    fxLayoutAlign="normal center">
    <mat-icon
      svgIcon="tuni-maletin-blanco"
      class="m-r-5"></mat-icon>
    <span>{{text}}</span>
    <ng-container *ngTemplateOutlet="templates.customContent;"></ng-container>
  </div>
  <ng-content></ng-content>
</mat-toolbar>
